import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 26,
  className = "",
  as = "div",
}) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};

// Section eyebrow label — mono, uppercase, quiet
export const Eyebrow = ({ children, tone = "muted", testId }) => {
  const color =
    tone === "signal" ? "text-signal" : "text-ink-muted";
  return (
    <div
      data-testid={testId}
      className={`font-mono text-xs uppercase tracking-[0.22em] ${color} flex items-center gap-2`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-signal" />
      {children}
    </div>
  );
};
